import { JSX } from 'react'

import { IconProps } from '../../icon'

const Historia: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M33.748 38.5465H20.321C18.443 38.5465 16.9207 36.9815 16.9207 35.0508C16.9207 35.0508 16.9207 12.5585 16.9207 11.653C16.9207 10.1545 15.9492 9.49902 15.9492 9.49902H30.8335C32.4432 9.49902 33.748 10.8405 33.748 12.4953V38.5465Z'
      fill='#F9D865'
    />
    <path
      d='M18.8238 38.5465H36.8745C38.601 38.5465 40.0005 37.147 40.0005 35.4205H21.3738C21.3738 35.4205 21.5968 35.73 21.0975 36.9835C20.5983 38.237 18.8238 38.5465 18.8238 38.5465Z'
      fill='#AAD3DC'
    />
    <path
      d='M36.8743 39.046H18.8235V38.9998C18.6332 39.0305 18.44 39.046 18.2475 39.046C16.2483 39.046 14.622 37.4195 14.622 35.4202V15.7303H11.865C10.0095 15.73 8.5 14.2205 8.5 12.365C8.5 10.5098 10.0095 9 11.865 9H30.8825C32.738 9 34.2475 10.5095 34.2475 12.365V34.921H40.5V35.4205C40.5 37.4198 38.8735 39.046 36.8743 39.046ZM20.7445 38.0473H36.874C38.1518 38.0473 39.2198 37.13 39.4533 35.9195H21.8387C21.724 36.7453 21.329 37.4913 20.7445 38.0473ZM14.4915 9.99875C15.1867 10.6597 15.6207 11.593 15.6207 12.6255V35.4202C15.6207 36.8687 16.7993 38.0473 18.2475 38.0473C18.4095 38.0473 18.5722 38.0323 18.7312 38.0025C19.9727 37.7685 20.874 36.6822 20.874 35.4202V34.9208H33.2485V12.365C33.2485 11.0603 32.187 9.99875 30.8822 9.99875H14.4915ZM11.865 9.99875C10.5603 9.99875 9.49875 11.0603 9.49875 12.365C9.49875 13.6698 10.5603 14.7315 11.865 14.7315H14.622V12.6255C14.622 11.177 13.4435 9.99875 11.9952 9.99875H11.865ZM31.5335 15.5995H17.466V16.5982H31.5335V15.5995ZM31.5335 18.552H17.466V19.5507H31.5335V18.552ZM31.5335 21.5047H17.466V22.5035H31.5335V21.5047ZM31.5335 24.4572H17.466V25.456H31.5335V24.4572ZM31.5335 27.4097H17.466V28.4085H31.5335V27.4097ZM31.5335 30.3625H17.466V31.3612H31.5335V30.3625Z'
      fill='black'
    />
  </svg>
)

export default Historia
